import React, { useEffect, useState } from 'react';
import { SectionLayout } from 'components/Sections/SectionLayout';
import { Col, Row } from 'components/Core/Grid';
import NavigationItem from './NavigationItem';
import MobileCarousel from '../MobileCarousel';
import InPageFeaturesV3FeaturedContent from './InPageFeaturesV3FeaturedContent';
import { updateTitleHeights, updateTitleLineBreaks } from './utils/domManipulation';
import { DesktopContainer, FeaturedContent, StyledTitle } from './styles';

const InPageFeaturesV3 = (props) => {
  const { index, inPageNavigationItems, title, toggleComponent } = props;

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [titleHeight, setTitleHeight] = useState(null);
  const [multiLineTitle, setMultiLineTitle] = useState(false);

  useEffect(() => {
    const titleDomElements = document.querySelectorAll(
      `.in-page-features--${index} .in-page-features-v3--title`,
    );

    updateTitleHeights(titleDomElements, setTitleHeight);
    updateTitleLineBreaks(setMultiLineTitle, titleDomElements, index);
  }, []);

  const featuredContent = inPageNavigationItems[selectedIndex];

  const handleClick = (idx) => {
    setSelectedIndex(idx);
  };

  const navigationItems = [[], []];

  inPageNavigationItems.forEach((item, idx) => {
    item.key = idx;
    idx % 2 === 0 ? navigationItems[0].push(item) : navigationItems[1].push(item);
  });

  const showTitle = title && !toggleComponent;

  return (
    <div id="in-page-features-v3" className="in-page-features-v3">
      {showTitle && <StyledTitle>{title}</StyledTitle>}

      <DesktopContainer
        itemLength={inPageNavigationItems.length}
        className={`in-page-features--${index} in-page-features-v3--desktop-container min-lg`}
        multiLineTitle={multiLineTitle}
      >
        <SectionLayout
          innerContainerStyles={`in-page-features-v3--inner-container ${
            showTitle ? 'title-included' : ''
          } ${toggleComponent ? 'toggle-component' : ''}`}
        >
          <Row type="flex" justify="center" gutter={40} className="in-page-features-v3--content">
            <Col
              xs={24}
              sm={12}
              className="in-page-features-v3--navigation"
              id={`in-page-features-v3--navigation--${index}`}
            >
              <Row type="flex" justify="start" gutter={20} style={{ width: '100%' }}>
                {navigationItems.map((column, index) => {
                  return (
                    <Col xs={12} key={`features-v3--nav-item-col-${index}`}>
                      <Row
                        type="flex"
                        justify="start"
                        gutter={[20, 20]}
                        className="in-page-features-v3--item-column"
                      >
                        {column.map((item, index) => {
                          return (
                            <Col
                              xs={24}
                              onClick={() => handleClick(item.key)}
                              key={`features-v3--nav-item-${index}`}
                              id={`inpagefeatures_v3_navitem_${item.contentful_id}`}
                            >
                              <NavigationItem
                                {...item}
                                selected={item.key === selectedIndex}
                                titleHeight={titleHeight}
                                multiLineTitle={multiLineTitle}
                              />
                            </Col>
                          );
                        })}
                      </Row>
                    </Col>
                  );
                })}
              </Row>
            </Col>
            <FeaturedContent xs={24} sm={12}>
              <div className="in-page-features-v3--featured-content">
                {selectedIndex === null && (
                  <div className="in-page-features-v3--featured-content-container">
                    <InPageFeaturesV3FeaturedContent item={featuredContent} />
                  </div>
                )}
                {inPageNavigationItems.map((item, index) => {
                  const isShown = selectedIndex === index;

                  return (
                    <div
                      className={`in-page-features-v3--featured-content-container ${
                        isShown ? 'show-feature' : 'hide-feature'
                      }`}
                      key={`featured-v3--content-container-${index}`}
                      id={`inpagefeatures_v3_content_${item.contentful_id}`}
                    >
                      <InPageFeaturesV3FeaturedContent item={item} />
                    </div>
                  );
                })}
              </div>
            </FeaturedContent>
          </Row>
        </SectionLayout>
      </DesktopContainer>

      <MobileCarousel
        className="max-lg"
        inPageNavigation={inPageNavigationItems}
        backgroundColor="#ffffff"
        title={showTitle && title}
      />
    </div>
  );
};

export default InPageFeaturesV3;
